import { Reveal, SectionLabel } from "@/components/Reveal";

const REASONS = [
  { title: "Approche globale et intégrative", text: "Nous considérons la personne dans sa globalité : corps, cœur, esprit, relations, environnement et spiritualité." },
  { title: "Exploration en profondeur", text: "Nous identifions les facteurs qui peuvent influencer vos difficultés pour agir à la source, pas seulement sur les symptômes." },
  { title: "Modèle d'intervention structuré", text: "Un parcours clair en 6 étapes pour vous guider du premier éclairage jusqu'à l'autonomie et au changement durable." },
  { title: "Intégration et consolidation", text: "Nous ne nous arrêtons pas à la prise de conscience. Nous vous accompagnons pour intégrer et consolider les changements dans votre quotidien." },
  { title: "Dimension spirituelle chrétienne", text: "Pour ceux qui le souhaitent, la foi et la prière peuvent être intégrées dans le respect de vos convictions. Jamais imposées, toujours à votre rythme." },
  { title: "15 ans d'expérience à votre service", text: "Plus de 15 ans d'expérience auprès d'adultes, de couples, de familles et d'organisations. Une expertise solide et éprouvée." },
  { title: "Une équipe expérimentée et passionnée", text: "Des professionnels compétents, humains et passionnés par l'accompagnement et le développement de la personne." },
  { title: "Tarifs concurrentiels et accessibles", text: "Des tarifs justes et adaptés à votre budget, sans compromis sur la qualité de l'accompagnement offert." },
  { title: "Un accompagnement humain et bienveillant", text: "Écoute, respect, confidentialité et non-jugement. Vous êtes accueilli tel que vous êtes, dans un cadre sécurisant et chaleureux." },
];

export default function WhyChoose() {
  return (
    <section data-testid="why-choose-section" className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-32 lg:px-24">
      <Reveal>
        <SectionLabel>Pourquoi nous choisir</SectionLabel>
        <h2 className="mt-8 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Votre transformation, <em className="text-sage-dark">notre mission</em>
        </h2>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-deep/70">
          Une démarche complète qui vous aide à comprendre en profondeur, à passer à l'action et à intégrer des changements durables dans votre vie.
        </p>
      </Reveal>

      <Reveal>
        <h3 className="mt-16 text-center text-xs uppercase tracking-[0.3em] text-gold">
          9 raisons qui nous distinguent
        </h3>
      </Reveal>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={(i % 3) * 0.08}>
            <div data-testid={`why-reason-${i + 1}`} className="flex h-full flex-col rounded-3xl border border-deep/10 bg-sand/40 p-7 transition-colors duration-500 hover:border-gold/40">
              <span className="font-serif text-3xl font-light italic text-gold">{String(i + 1).padStart(2, "0")}</span>
              <h4 className="mt-4 font-serif text-xl font-light uppercase leading-snug tracking-wide text-deep">{r.title}</h4>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-deep/60">{r.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
